import { ReactComponent as TemplateIcon } from "assets/svg/theStoryBehind.svg";
import { SurveyTemplate } from "../../types";
import { getContestDefaults } from "../helpers";

export const theStoryBehind: SurveyTemplate = {
  icon: <TemplateIcon />,
  title: "The Story Behind…",
  description: "Allow fans to vote on which song you tell the story behind.",
  templateId: "theStoryBehind",
  template: (v, formState) => ({
    fields: {
      description: {
        content: {
          en: "The Story Behind…",
        },
      },
      ...getContestDefaults(formState),
    },
    surveyQuestions: [
      {
        id: "question_1",
        type: "SingleSelectQuestion",
        actionRequired: true,
      },
    ],
    ...(formState.hasSweeps === "Yes" && {
      flags: {
        showContestConfirmationMessage: true,
      },
    }),
  }),
  prompt: {
    promptId: (state) =>
      state.hasSweeps === "Yes"
        ? "pp-livestream-ba24ed"
        : "pp-livestream-50566a",
    fields: [
      {
        name: "date",
        type: "text",
        label: "When does your livestream take place?",
        placeholder: "Enter your answer...",
        getValidation: (fields) =>
          fields.date ? false : "This field cannot be left blank",
      },
      {
        name: "hasSweeps",
        type: "radio",
        label: "Will you be offering a sweepstakes prize?",
        options: ["Yes", "No"],
        getValidation: (fields) =>
          !!fields.hasSweeps ? false : "You must select an option.",
      },
      {
        name: "prize",
        type: "text",
        label: "What's the prize?",
        placeholder: "Enter your answer...",
        getValidation: (fields) =>
          fields.prize || fields.hasSweeps === "No"
            ? false
            : "This field cannot be left blank",
        isVisible: (form) => form.hasSweeps === "Yes",
      },
    ],
  },
};
